import { render, staticRenderFns } from "./IconTypeformRanking.vue?vue&type=template&id=1997eaec&"
import script from "./IconTypeformRanking.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformRanking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports